<script  lang="ts">
    import { imageLink, ToFormData } from "@frontend/helpers";
    import { service } from "@frontend/services";
    import { GetCachedToken } from "@frontend/user";
    import { ApiResultOfGame, ApiResultOfPublicGamesDTO, AuthenticatedRequestOfEditGameDTO, Game } from "@frontend/walletapi";
    import { translate, currentLanguage } from "../Translator";
  
    export let game: Game;
    export let dismiss: () => void;

    let fileInput: HTMLInputElement | undefined = undefined;
  
    let result: ApiResultOfGame | undefined = undefined;
  
    async function EditGame()
    {

        const editGameRequest: AuthenticatedRequestOfEditGameDTO = {
            Token: GetCachedToken(),
            Data: game,
        };

        try {
            const formData = new FormData();

            // if image type is upload, remove Select from the game
            if (imageType == "upload")
            {
                game.Select = undefined;
            }

            // if image type is link, set selected file to empty string
            if (imageType == "link")
            {
                fileInput!.files = null;
            }

            // Append AddGamesDTO JSON string as a part of the FormData
            ToFormData(editGameRequest, formData, "editGame");

            // Append the file as a separate part
            if (fileInput?.files?.[0])
            {
                formData.append('file', fileInput.files[0]);
            }

            const responseHeaders = await fetch(service.Route("/EditGame"), {
                method: 'POST',
                body: formData
            });

            result = await responseHeaders.json();

            if (result?.Success && result?.Data)
            {
                console.log("Game added successfully:", result.Data);
                dismiss();
            }
            else
            {
                console.error("Error adding game:", result?.ErrorMessage);
            }

        } catch (error) {
            console.error("Error adding game:", error);
        }
    }

    async function ToggleEnable()
    {
        game = {
            ...game,
            Enabled: !game.Enabled
        }

        console.log("EditGame", game);
    }
  
    let imageType: "upload" | "link" = game?.Select?.startsWith("http") ? "link" : "upload";

    function changeImageType(type: "upload" | "link")
    {
        imageType = type;
    }
  </script>
  
  
  <h2 class="ui centered dividing header">{$translate('Edit')} #{game.Id}</h2>
  {#if result && result.Success && result.Data}
      <div class="ui positive message">
          <div class="header">
              {game.GameCode} {$translate('Edited successfully')}
          </div>
      </div>
  
      <div class="ui segment" style="display: flex;">
          <table class="receit-table" style="flex-grow: 1;">
              <tr>
                  <td class="receit-title">{$translate('Id')}</td>
                  <td class="receit-value">#{result.Data.Id}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Game code')}</td>
                  <td class="receit-value">{result.Data.GameCode}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Game Name')}</td>
                  <td class="receit-value">{result.Data.GameName ?? ""}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Enabled')}</td>
                  <td class="receit-value">{result.Data.Enabled ?? ""}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Select')}</td>
                  <td class="receit-value">{result.Data.Select ?? ""}</td>
              </tr>
          </table>
      </div>
  
      <div style="display: flex; justify-content: center;">
          <button class="ui primary fluid button" on:click={dismiss}>{$translate('Dismiss')}</button>
          <button class="ui fluid button">{$translate('Print')}</button>
      </div>
  {:else}
      {#if result && !result.Success}
          <div class="ui negative message">
              <div class="header">Error</div>
              <p>{result.ErrorMessage ?? `Unknown error when adding ${game.GameCode}`}</p>
          </div>
      {/if}
      <form class="ui positive form" on:submit|preventDefault={EditGame}>
          <div class="field">
              <label>{$translate('Game code')}
                  <input type="text" class="ui input" placeholder="Game code..." bind:value={game.GameCode}  required/>
              </label>
          </div>
          <div class="field">
              <label>{$translate('Game Name')}
                  <input type="text" class="ui input" placeholder="Game name..." bind:value={game.GameName}  required/>
              </label>
          </div>
          <!-- <div class="field">
                <label for="">Enabled</label>
                {#if game.Enabled}
                    <button class={`ui icon button ${game.Enabled ? 'positive' : 'negative'}`} on:click|preventDefault={ToggleEnable} style="display: block">
                        <i class="check  icon"></i>
                    </button>
                {:else}
                    <button class={`ui icon button ${game.Enabled ? 'positive' : 'negative'}`} on:click|preventDefault={ToggleEnable} style="display: block">
                        <i class="close icon"></i>
                    </button>
                {/if}
          </div> -->
          <div class="two fields">
            <div class="field">
                <!-- <label>Upload
                    <input type="file" class="ui input" bind:this={fileInput} accept="image/*" />
                </label>
                <label>Paste link
                    <input type="text" class="ui input" bind:value={game.Select} />
                </label> -->

                <div class="ui top attached tabular menu">
                    <button class="item" class:active={imageType == "upload"} on:click|preventDefault={() => changeImageType("upload")}>Upload</button>
                    <button class="item" class:active={imageType == "link"} on:click|preventDefault={() => changeImageType("link")}>Link</button>
                </div>
                <div class="ui bottom attached segment">
                    {#if imageType == "upload"}
                        <input type="file" class="ui input" bind:this={fileInput} accept="image/*" />
                    {:else}
                        <input type="text" class="ui input" bind:value={game.Select} />
                    {/if}
                </div>
            </div>
            <div class="field">
                <label for="">{$translate('Existing imagen')}
                    <div class="image-preview-container">
                        <img src="{game.Select ? imageLink(game.Select) : ''}" alt="" class="image-preview" />
                    </div>
                </label>
            </div>
        </div>
          <div class="two field" style="display: flex">
              <button class="ui negative fluid button" on:click|preventDefault={dismiss}>{$translate('Cancel')}</button>
              <button class="ui positive fluid button">{$translate('Save')}</button>
          </div>
      </form>
  {/if}
  
  <style>
      .receit-table
      {
          border-spacing: 0px;
          font-family: 'Courier New', Courier, monospace;
      }

      .receit-table td
      {
          padding-top: 5px;
      }

      .receit-table td:first-child
      {
          margin-right: 0.2em;
      }

      .receit-title
      {
          text-align: left;
          border-bottom: 1px solid black;
          padding-right: 10px;
      }

      .receit-value
      {
          text-align: right;
          border-bottom: 1px solid black;
      }

      .image-preview-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px;
          border: 2px dashed #ddd;
          border-radius: 8px;
          background-color: #f9f9f9;
          min-height: 200px;
          max-height: 300px;
          overflow: hidden;
      }

      .image-preview {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          border-radius: 4px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      /* Responsive adjustments */
      @media (max-width: 768px) {
          .image-preview-container {
              min-height: 150px;
              max-height: 200px;
          }
      }

      @media (max-width: 480px) {
          .image-preview-container {
              min-height: 120px;
              max-height: 150px;
          }
      }
  </style>
  
  